<div class="xr-auth-stack">
  <span class="xr-auth-badge" aria-hidden="true">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5 9-10"/></svg>
  </span>
  <div>
    <h1 class="xr-auth-title">{{ "recovery_password.done_title" | translate }}</h1>
    <p class="xr-auth-subtitle">{{ "recovery_password.password_reset_done" | translate }}</p>
  </div>
  <button type="button" (click)="goLogin()" class="xr-btn xr-btn--primary xr-auth-submit">
    {{ "login.submit" | translate }}
  </button>
</div>
